import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20library%20with%20warm%20amber%20lighting%2C%20classical%20wooden%20bookshelves%20filled%20with%20ancient%20bound%20volumes%2C%20soft%20diffused%20light%20streaming%20through%20traditional%20lattice%20windows%2C%20elegant%20calligraphy%20scrolls%20hanging%20on%20walls%2C%20scholarly%20atmosphere%20with%20ink%20stone%20and%20brush%20on%20dark%20wood%20desk%2C%20rich%20brown%20and%20cream%20tones%2C%20atmospheric%20and%20timeless%20academic%20setting&width=1600&height=900&seq=hero-ypt-01&orientation=landscape"
        alt="古典文学研究 - 玉蒲团经典文化解析"
        title="玉蒲团经典文化作品完全解析"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          玉蒲团
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-3 font-medium">
          经典文化作品完全解析
        </p>
        <p className="text-sm md:text-base text-white/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          深度解析《玉蒲团》的历史背景、文学价值、版本流传与文化影响，带您全面了解这部中国古典文学传奇之作的艺术魅力与人文内涵。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/literary-value"
            className="px-6 py-3 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            探索文学价值
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}